// extracted by mini-css-extract-plugin
export default {"container":"home-page_container__zcMfg","mobile_view":"home-page_mobile_view__IMwls"};